import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import api from '../../../seller-apis/api';
import { fetchAllNotifications } from '../../../seller-apis/apidataField';
import moment from "moment";
import Pagination from '../PaginationComponent/index';
import { useDispatch, useSelector } from "react-redux";
import { Actions } from "../../../Actions/Actions";

var dateFromWeb = moment().subtract(15, 'days').format('YYYY-MM-DD');
var dateToWeb = moment().format('YYYY-MM-DD');

  function VerifyWeightTab({ onCountUpdate, refreshTrigger, onNotificationClosed, refreshGlobalCount }) {

  const [notificationsList, setNotificationsList] = useState([]);
  const [currPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [processingId, setProcessingId] = useState(null);

  const dispatch = useDispatch();
  const itemsPerPage = 5;

  const globalFilter = {
    pageNo: currPage,
    size: itemsPerPage,
    filters: {
      type: { $in: ["WEIGHT_CHANGED"] },
      "from-createdAt": dateFromWeb + 'T00:00:00.000Z',
      "to-createdAt": dateToWeb + 'T23:59:59.000Z',
      opened: false
    },
  };

   useEffect(() => {
    fetchNotifications();
  }, [currPage, refreshTrigger]); // ✅ Added refreshTrigger


  const fetchNotifications = () => {
    api.notify.fetchWeightChangedNotifications(fetchAllNotifications({ ...globalFilter, pageNo: currPage }))
      .then(res => {
        setNotificationsList(res.data);
        setTotalRecords(res.totalRecords);
        if (currPage === 1) {
          onCountUpdate(res.totalRecords);
        }

        // const countData = {
        //   pageNo: 1,
        //   size: 1,
        //   filters: {
        //     type: { $in: ["PRC_CHANGED", "NEW_PRODUCT", "WEIGHT_CHANGED"] },
        //     opened: false,
        //     "from-createdAt": dateFromWeb + 'T00:00:00.000Z',
        //     "to-createdAt": dateToWeb + 'T23:59:59.000Z'
        //   },
        // };
        
        // api.notify
        //   .fetchNotifications(fetchAllNotifications(countData))
        //   .then((res) => {
        //     Actions.updateNotificationCount(dispatch, res.totalRecords);
        //   })
        //   .catch((err) => console.log(err));
      })
      .catch(err => console.log(err));
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const formatDate = (dateString) => {
    let date = new Date(dateString);
    return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  const getCombination = (item) => {
    let cmb = "";
    if (item.productDetails && item.productDetails.value) {
      item.productDetails.value.forEach((litem, lindex) => {
        cmb = cmb + litem;
        if (lindex !== item.productDetails.value.length - 1) {
          cmb = cmb + " x ";
        }
      });
    }
    return cmb;
  };

 const handleVerifyWeight = async (item) => {
    try {
      setProcessingId(item._id);
      
      const productId = String(item._id);
      const vendorId = String(item.vendor);
      
      await api.notify.closeVendorWeightNotification(productId, vendorId);
      
      setNotificationsList(prevList => prevList.filter(notification => notification._id !== item._id));
      setTotalRecords(prevTotal => prevTotal - 1);
      
      if (currPage === 1) {
        onCountUpdate(Math.max(0, totalRecords - 1));
      }
      
      // ✅ Notify parent to refresh other tabs
      if (onNotificationClosed) {
        onNotificationClosed();
      }

      if (refreshGlobalCount) {
        refreshGlobalCount();
      }
    // ✅ Determine URL based on product type
    let url;
    
    // Check if it's a combination product (has combination weight notifications)
    if (item.hasCombinationWeightNotification && item.combination && item.combination.length > 0) {
      // Get the first combination URL
      const firstCombination = item.combination[0];
      
      if (firstCombination && firstCombination.url) {
        // Combination product URL
        url = `/productDetConf/${item._id}?url=${firstCombination.url}`;
      } else {
        // Fallback to standard product
        url = `/productDetail/${item._id}/approv`;
      }
    } else {
      // Standard product (main weight notification)
      url = `/productDetail/${item._id}/approv`;
    }
    
    window.open(url, '_blank');
    
    setTimeout(() => {
      fetchNotifications();
    }, 1000);
    
  } catch (error) {
    console.error('Error:', error);
    setTimeout(() => {
      fetchNotifications();
    }, 500);
  } finally {
    setProcessingId(null);
  }
};

  return (
    <>
      {notificationsList && notificationsList.map((item, index) => {
        const cmb = getCombination(item);
        const isProcessing = processingId === item._id;

        return (
          <div key={index} className="pn-card">
            <div className="pn-card-row">
              <div className="pn-img-col">
                {item.productDetails && item.productDetails.images && item.productDetails.images.map((img, imgIndex) => {
                  if (img.baseImage) {
                    return (
                      <img 
                        key={imgIndex}
                        className='pn-product-img'
                        src={`https://s3.toolsvilla.com/${img.image}`}
                        alt="product" 
                      />
                    );
                  }
                  return null;
                })}
              </div>
              <div className="pn-content-col">
                <div className="pn-card-content">
                  <div className="pn-title-row">
                    <h6 className="pn-product-title">
                      {item.productDetails && item.productDetails.productName}
                    </h6>
                    <span className="pn-date">{formatDate(item.createdAt)}</span>
                  </div>

                  {cmb && (
                    <span className="pn-combination-badge">
                      {cmb}
                    </span>
                  )}

                  <p className="pn-notes">{item.notes}</p>
                  
                  <button 
                    className={`pn-action-btn ${isProcessing ? 'pn-disabled' : ''}`}
                    onClick={() => handleVerifyWeight(item)}
                    disabled={isProcessing}
                  >
                    {isProcessing ? 'Processing...' : 'Verify Weight'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
      })}

      {notificationsList && notificationsList.length === 0 && (
        <div className="pn-empty-state">
          <h6 className="pn-empty-title">No Notifications</h6>
        </div>
      )}

      {totalRecords > 0 && (
        <div className="pn-pagination-wrapper">
          <Pagination
            currentPage={currPage}
            totalRecords={totalRecords}
            itemsPerRow={itemsPerPage}
            handlePageChange={handlePageChange}
          />
        </div>
      )}
    </>
  );
}

export default VerifyWeightTab;